// Hummin — first-visit loading entrance.
// Logo image fades in, then page reveals via mask. ~900ms total.
// Skipped if user already saw it this session OR prefers-reduced-motion.

(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  if (sessionStorage.getItem('hummin-entrance-seen')) return;

  // Build overlay using safe DOM methods (no innerHTML)
  const overlay = document.createElement('div');
  overlay.className = 'hummin-entrance';
  overlay.setAttribute('aria-hidden', 'true');

  const logoWrap = document.createElement('div');
  logoWrap.className = 'hummin-entrance__logo';

  const img = document.createElement('img');
  img.src = window.HumminLogoUrl || '/cdn/shop/files/hummin-logo.webp';
  img.alt = '';

  logoWrap.appendChild(img);
  overlay.appendChild(logoWrap);
  document.documentElement.appendChild(overlay);
  document.documentElement.classList.add('is-entering');

  // Trigger reveal sequence (double rAF ensures CSS picks up initial state)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => overlay.classList.add('is-active'));
  });

  // After ~700ms, start fade-out
  setTimeout(() => {
    overlay.classList.add('is-leaving');
  }, 700);

  // Cleanup at ~1100ms
  setTimeout(() => {
    overlay.remove();
    document.documentElement.classList.remove('is-entering');
    sessionStorage.setItem('hummin-entrance-seen', '1');
  }, 1100);
})();
